import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default {
  path: '/media/',
  name: 'media',
  meta: {
    auth: true
  },
  redirect: {
    name: 'media/index'
  },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'index',
      name: `${pre}index`,
      component: _import('media/tree/index'),
      meta: {
        title: '账号列表'
      }
    }
  ])('media/')
}
